import {ON_REGIONS_LIST} from '../constants/ActionTypes';

const INIT_STATE = {
    regionsList: []
};


export default (state=INIT_STATE,action) => {
    switch (action.type){

        case ON_REGIONS_LIST: {
            return {...state, regionsList: action.payload};
        }
        default:
            return state;
    }
}